import {
   PreciseDosage,
   Prescription,
   PrescriptionPackagePrescription,
} from '@dreryk/egabinet-prescription-frontend-api';

import { Choice } from '@dreryk/watermelon';

import { calculateNewIssuedToLocalDate, ExtendedDosage, getIssuedFromDefaultValue } from '~libs.shared.prescription';

export const mapPackagePrescriptionToDraft = (prescription: PrescriptionPackagePrescription): Prescription => ({
   additionalEntitlementTypes: prescription.additionalEntitlementTypes,
   cito: false,
   displayIndex: prescription.displayIndex,
   dosage: Choice.withUseDefaultIfNull<string>(prescription.dosage ?? null),
   id: prescription.id,
   issuedFrom: prescription.issuedFrom,
   issuedTo: prescription.issuedTo,
   medicineId: prescription.medicinePrescription?.patientMedicine?.medicine?.id,
   quantity: prescription.quantity,
   reimbursementType: Choice.withUseDefaultIfNull(prescription.reimbursementType ?? null),
   substituteForbidden: prescription.substituteForbidden,
   preciseDosage: Choice.withUseDefaultIfNull(prescription.preciseDosage ?? null),
   extendedDosage: Choice.withUseDefaultIfNull(prescription.extendedDosage ?? null),
   treatmentDays: Choice.withUseDefault<number>(),
});

export const createReplacementPrescription = (medicineId: number, displayIndex: number): Prescription => {
   const issuedFrom = getIssuedFromDefaultValue();
   const issuedTo = calculateNewIssuedToLocalDate(issuedFrom, false) ?? issuedFrom;

   return {
      additionalEntitlementTypes: [],
      cito: false,
      displayIndex: displayIndex,
      dosage: Choice.withUseDefault<string>(),
      medicineId: medicineId,
      quantity: 1,
      issuedFrom: issuedFrom,
      issuedTo: issuedTo,
      substituteForbidden: false,
      preciseDosage: Choice.withUseDefault<PreciseDosage>(),
      extendedDosage: Choice.withUseDefault<ExtendedDosage>(),
      treatmentDays: Choice.withUseDefault<number>(),
   };
};
